import UnauthenticatedRoute from './UnauthenticatedRoute';

export default UnauthenticatedRoute;
